// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table{
  width: 100%;
}

      .border-red{
          border: 1px solid #af4a53;
      }
  .span{
      position: relative;
                                                      border-radius: 50%;
                                                      background: #fff;
                                                      width: 26px;
                                                      height: 26px;
                                                      border: solid 1px #ccc;
                                                      text-align: center;
                                                      vertical-align: middle;
                                                      display: inline-block;
                                                      margin-left: 0.25rem;
  }
  
  /*---------ACTIVE COMPLAINTS-----------------*/
  .active_complaints tbody{
  max-height: 148px;
  overflow-y: auto;
  display: block; 
  
  height: 148px;
  }
  .active_complaints tbody td{
      width: 100%;
      display: inline-block;
       /* display: table; */
  }
  .active_complaints tbody td input{
      display: inline;
  }
/*---------ACTIVE COMPLAINTS-----------------*/



 .clinical_forms  tbody,
  .existing_conditions tbody,
  .family_history tbody,
  .events_in_24 tbody,
   .surgical_history tbody{
  max-height: 151px;
  overflow-y: auto;
  display: block; 
  height: 151px;
  }
  .clinical_forms  tbody{
    max-height: 138px;
    overflow-y: auto;
    display: block; 
    height: 138px;
  }
  .active_medication tbody{
    max-height: 138px;
    overflow-y: auto;
    display: block; 
    height: 138px;
  }
  .latest_vitals tbody{
      max-height: 162px;
      overflow-y: auto;
      display: block; 
      height: 162px; 
  }
  .latest_vitals tbody tr,
  .active_medication tbody tr,
   .existing_conditions tbody tr,
   .family_history tbody tr,
   .events_in_24 tbody tr, 
   .surgical_history tbody tr,
   .social_history tbody tr{
      width: 100%;
       display: table;
  }
  .clinical_forms  tbody tr{
    width: 100%;
    display: table;
    
   }
  
  .active_diagnosis tbody{
      max-height: 160px;
  overflow-y: auto;
  display: block; 
  
  height: 160px;

  }

  .active_diagnosis tbody tr{
      width: 100%;
       display: table;

  }
  .current_orders tbody{
      max-height: 138px;
  overflow-y: auto;
  display: block; 
  
  height: 138px;

  }
  .current_orders  tbody tr{
      width: 100%;
      display: table;
  } 
  /* .active_medication tbody{
      max-height: 148px;
  overflow-y: auto;
  display: block; 
  
  height: 148px;

  } */
  .active_medication  tbody tr{
      width: 100%;
       

  } 

  .social_history tbody{
      max-height: 142px;
      overflow-y: auto;
      display: block; 
      height: 142px;
  }


  .family_history tbody{
      max-height: 128px;
  overflow-y: auto;
  display: block; 
  
  height: 128px;
  
  }
  .family_history tbody tr{
      width: 100%;
       display: table;
  }
  
/*---------ORDERS ORDER-----------------*/
  
  .orders_order table{
      height: 140px;
  }
  .orders_order tbody{
      height:130pxpx;
      
      display: block;
      overflow-y: auto;
      max-height: 130px;
  }
  .orders_order tbody tr{
      width: 100%;
       display: table;
  }
/*---------ORDERS ORDER-----------------*/
  .active_allergy tbody{
      max-height: 149px;
  overflow-y: auto;
  display: block; 
  
  height: 149px;
  }
  .active_allergy tbody tr {
      
      width: 100%;
      display: table;
  }
  .active_allergy tbody tr th td{
      width: 120px;
  }
 .table-bordered-right{border-right:solid 1px #dee2e6;}


 .text-secondary a{
     color: #d24350;
 } 
 .text-primary a{
    color: #d24350;
 }
 .text-primary{
    color: #d24350;
 }
 .text-secondary a:hover{
    color: #d24350;
} 
.text-primary a:hover{
   color: #d24350;
}
/* .btn.btn-outline-primary {
    border-color: #f44336;
    color: #f44336;
} */

.text-herd:hover{
   background-color: #9e9e9e24;;
}
.text-herd{
    padding: 0.4rem 0.5rem;
    line-height: 1.5;
}

.btnSize{
  width: 160.69px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/scss/ipd/patient_chart_summary.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;MAEM;UACI,yBAAyB;MAC7B;EACJ;MACI,kBAAkB;sDAC8B,kBAAkB;sDAClB,gBAAgB;sDAChB,WAAW;sDACX,YAAY;sDACZ,sBAAsB;sDACtB,kBAAkB;sDAClB,sBAAsB;sDACtB,qBAAqB;sDACrB,oBAAoB;EACxE;;EAEA,8CAA8C;EAC9C;EACA,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;;EAEd,aAAa;EACb;EACA;MACI,WAAW;MACX,qBAAqB;OACpB,oBAAoB;EACzB;EACA;MACI,eAAe;EACnB;AACF,8CAA8C;;;;CAI7C;;;;;EAKC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;EACA;MACI,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,aAAa;EACjB;EACA;;;;;;;MAOI,WAAW;OACV,cAAc;EACnB;EACA;IACE,WAAW;IACX,cAAc;;GAEf;;EAED;MACI,iBAAiB;EACrB,gBAAgB;EAChB,cAAc;;EAEd,aAAa;;EAEb;;EAEA;MACI,WAAW;OACV,cAAc;;EAEnB;EACA;MACI,iBAAiB;EACrB,gBAAgB;EAChB,cAAc;;EAEd,aAAa;;EAEb;EACA;MACI,WAAW;MACX,cAAc;EAClB;EACA;;;;;;;KAOG;EACH;MACI,WAAW;;;EAGf;;EAEA;MACI,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,aAAa;EACjB;;;EAGA;MACI,iBAAiB;EACrB,gBAAgB;EAChB,cAAc;;EAEd,aAAa;;EAEb;EACA;MACI,WAAW;OACV,cAAc;EACnB;;AAEF,yCAAyC;;EAEvC;MACI,aAAa;EACjB;EACA;MACI,cAAc;;MAEd,cAAc;MACd,gBAAgB;MAChB,iBAAiB;EACrB;EACA;MACI,WAAW;OACV,cAAc;EACnB;AACF,yCAAyC;EACvC;MACI,iBAAiB;EACrB,gBAAgB;EAChB,cAAc;;EAEd,aAAa;EACb;EACA;;MAEI,WAAW;MACX,cAAc;EAClB;EACA;MACI,YAAY;EAChB;CACD,sBAAsB,8BAA8B,CAAC;;;CAGrD;KACI,cAAc;CAClB;CACA;IACG,cAAc;CACjB;CACA;IACG,cAAc;CACjB;CACA;IACG,cAAc;AAClB;AACA;GACG,cAAc;AACjB;AACA;;;GAGG;;AAEH;GACG,2BAA2B;AAC9B;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".table{\n  width: 100%;\n}\n\n      .border-red{\n          border: 1px solid #af4a53;\n      }\n  .span{\n      position: relative;\n                                                      border-radius: 50%;\n                                                      background: #fff;\n                                                      width: 26px;\n                                                      height: 26px;\n                                                      border: solid 1px #ccc;\n                                                      text-align: center;\n                                                      vertical-align: middle;\n                                                      display: inline-block;\n                                                      margin-left: 0.25rem;\n  }\n  \n  /*---------ACTIVE COMPLAINTS-----------------*/\n  .active_complaints tbody{\n  max-height: 148px;\n  overflow-y: auto;\n  display: block; \n  \n  height: 148px;\n  }\n  .active_complaints tbody td{\n      width: 100%;\n      display: inline-block;\n       /* display: table; */\n  }\n  .active_complaints tbody td input{\n      display: inline;\n  }\n/*---------ACTIVE COMPLAINTS-----------------*/\n\n\n\n .clinical_forms  tbody,\n  .existing_conditions tbody,\n  .family_history tbody,\n  .events_in_24 tbody,\n   .surgical_history tbody{\n  max-height: 151px;\n  overflow-y: auto;\n  display: block; \n  height: 151px;\n  }\n  .clinical_forms  tbody{\n    max-height: 138px;\n    overflow-y: auto;\n    display: block; \n    height: 138px;\n  }\n  .active_medication tbody{\n    max-height: 138px;\n    overflow-y: auto;\n    display: block; \n    height: 138px;\n  }\n  .latest_vitals tbody{\n      max-height: 162px;\n      overflow-y: auto;\n      display: block; \n      height: 162px; \n  }\n  .latest_vitals tbody tr,\n  .active_medication tbody tr,\n   .existing_conditions tbody tr,\n   .family_history tbody tr,\n   .events_in_24 tbody tr, \n   .surgical_history tbody tr,\n   .social_history tbody tr{\n      width: 100%;\n       display: table;\n  }\n  .clinical_forms  tbody tr{\n    width: 100%;\n    display: table;\n    \n   }\n  \n  .active_diagnosis tbody{\n      max-height: 160px;\n  overflow-y: auto;\n  display: block; \n  \n  height: 160px;\n\n  }\n\n  .active_diagnosis tbody tr{\n      width: 100%;\n       display: table;\n\n  }\n  .current_orders tbody{\n      max-height: 138px;\n  overflow-y: auto;\n  display: block; \n  \n  height: 138px;\n\n  }\n  .current_orders  tbody tr{\n      width: 100%;\n      display: table;\n  } \n  /* .active_medication tbody{\n      max-height: 148px;\n  overflow-y: auto;\n  display: block; \n  \n  height: 148px;\n\n  } */\n  .active_medication  tbody tr{\n      width: 100%;\n       \n\n  } \n\n  .social_history tbody{\n      max-height: 142px;\n      overflow-y: auto;\n      display: block; \n      height: 142px;\n  }\n\n\n  .family_history tbody{\n      max-height: 128px;\n  overflow-y: auto;\n  display: block; \n  \n  height: 128px;\n  \n  }\n  .family_history tbody tr{\n      width: 100%;\n       display: table;\n  }\n  \n/*---------ORDERS ORDER-----------------*/\n  \n  .orders_order table{\n      height: 140px;\n  }\n  .orders_order tbody{\n      height:130pxpx;\n      \n      display: block;\n      overflow-y: auto;\n      max-height: 130px;\n  }\n  .orders_order tbody tr{\n      width: 100%;\n       display: table;\n  }\n/*---------ORDERS ORDER-----------------*/\n  .active_allergy tbody{\n      max-height: 149px;\n  overflow-y: auto;\n  display: block; \n  \n  height: 149px;\n  }\n  .active_allergy tbody tr {\n      \n      width: 100%;\n      display: table;\n  }\n  .active_allergy tbody tr th td{\n      width: 120px;\n  }\n .table-bordered-right{border-right:solid 1px #dee2e6;}\n\n\n .text-secondary a{\n     color: #d24350;\n } \n .text-primary a{\n    color: #d24350;\n }\n .text-primary{\n    color: #d24350;\n }\n .text-secondary a:hover{\n    color: #d24350;\n} \n.text-primary a:hover{\n   color: #d24350;\n}\n/* .btn.btn-outline-primary {\n    border-color: #f44336;\n    color: #f44336;\n} */\n\n.text-herd:hover{\n   background-color: #9e9e9e24;;\n}\n.text-herd{\n    padding: 0.4rem 0.5rem;\n    line-height: 1.5;\n}\n\n.btnSize{\n  width: 160.69px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
